export const POST_TYPES = [
  "Share whats on your mind",
  "Blood Donation Needed",
  "Business",
  "Meet Up",
  "Tour",
  "Friendly Genjam",
  "Emergency",
  "Congratulatory",
  "Ajaira Post",
];

export const DEFAULT_POST_TYPE = "Share whats on your mind";

export const POST_TYPE_STYLES = {
  "Share whats on your mind": {
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbfa 100%)",
    borderColor: "#e8eeeb",
    tagColor: "green",
    accent: "#5f7a70",
    icon: "💭",
  },
  "Blood Donation Needed": {
    background: "linear-gradient(180deg, #fff1f1 0%, #ffe7e7 100%)",
    borderColor: "#ffd4d4",
    tagColor: "red",
    accent: "#cf3d3d",
    icon: "🩸",
  },
  Business: {
    background: "linear-gradient(180deg, #f4faff 0%, #eaf5ff 100%)",
    borderColor: "#d8ebff",
    tagColor: "blue",
    accent: "#2a6ea6",
    icon: "💼",
  },
  "Meet Up": {
    background: "linear-gradient(180deg, #f8f5ff 0%, #efe8ff 100%)",
    borderColor: "#e4d8ff",
    tagColor: "purple",
    accent: "#6c49a8",
    icon: "🤝",
  },
  Tour: {
    background: "linear-gradient(180deg, #f3fbff 0%, #e6f6ff 100%)",
    borderColor: "#d6eefc",
    tagColor: "cyan",
    accent: "#2b7f95",
    icon: "🧭",
  },
  "Friendly Genjam": {
    background: "linear-gradient(180deg, #fff9ef 0%, #fff1da 100%)",
    borderColor: "#ffe7be",
    tagColor: "gold",
    accent: "#9b7a2d",
    icon: "😄",
  },
  Emergency: {
    background: "linear-gradient(180deg, #fff3f0 0%, #ffe7e2 100%)",
    borderColor: "#ffd5cc",
    tagColor: "volcano",
    accent: "#b5492c",
    icon: "🚨",
  },
  Congratulatory: {
    background: "linear-gradient(180deg, #f4fff5 0%, #e9fbe9 100%)",
    borderColor: "#d3f0d3",
    tagColor: "lime",
    accent: "#3d8e50",
    icon: "🎉",
  },
  "Ajaira Post": {
    background: "linear-gradient(180deg, #fafafa 0%, #f2f2f2 100%)",
    borderColor: "#e7e7e7",
    tagColor: "default",
    accent: "#7a7a7a",
    icon: "😂",
  },
};
